<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <innerHeaderDiy />
      <ProposalSubmissionPage />
    </div>
  </div>
</template>

<script>
import ProposalSubmissionPage from '@/components/ProposalSubmissionPage.vue';
import innerHeaderDiy from '@/components/header/innerHeaderDiy';

export default {
  name: 'ProposalSubmissionView',
  components: {
    ProposalSubmissionPage,
    innerHeaderDiy,
  },
};
</script>
